const getters = {
  // sidebar: state => state.app.sidebar,
  // language: state => state.app.language,
  // visitedViews: state => state.tagsView.visitedViews,
  // cachedViews: state => state.tagsView.cachedViews,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // status: state => state.user.status,
  // roles: state => state.user.roles,
  // setting: state => state.user.setting,
  // permission_routers: state => state.permission.routers,
  // addRouters: state => state.permission.addRouters,
   //errorLogs: state => state.errorLog.logs
  language: state=>state.ui.language,
  countries: state=>{
    const language = state.ui.language || 'en';
    const countries = state.core.countries;

    return countries.map(c=>{
     let id = c.iso_code;

     let name = c.name;
     if(language!='en' && c.translations  && c.translations[language]){
       name = c.translations[language]
     }
     return {
       id,
       name
     }
    }).sort((a,b)=>a.name.localeCompare(b.name))
  },
  languages: state=>{
    const language = state.ui.language || 'en';
    const languages = state.core.languages;

    return languages.map(c=>{
     let id = c.id;
     let name = c.name;
     if(language!='en' && c.translations  && c.translations[language]){
       name = c.translations[language]
     }
     return {
       id,
       name
     }
    });
  }
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js